<div class="setting-page">
  <legend>Registration Routing Settings</legend>
  <arm-form (submitForm)="submit()" *ngIf="isRegistrationEnabled" [validateForm]=false [disableSubmit]="!isUnauthorized
    || (registrationSettings.enabled && (!registrationSettings.registrationPropertyId || registrationSettings.dailablePropertyIds.length === 0))">
    <arm-form-title>registration setting</arm-form-title>
    <div class="settings-section">
      <div class="arm-checkbox">
        <mat-checkbox name="enableRegistration" color="primary" [(ngModel)]="registrationSettings.enabled">Enable users property for registration</mat-checkbox>
      </div>
      <ac-input-container label="Registration property"
                          [customError]="registrationSettings.enabled && !registrationSettings.registrationPropertyId ? 'property is required' : ''"
                          [required]="registrationSettings.enabled && !registrationSettings.registrationPropertyId">
        <ac-select [acModel]="registrationSettings.registrationPropertyId"
                   (acModelChange)="registrationSettings.registrationPropertyId = $event"
                   [items]="dictionaryProperties"
                   [bindValue]="'id'"
                   [bindLabel]="'name'"
                   [allowClear]="true"
                   alternativeName="registrationSettings.registrationPropertyId"
                   selectId="registration-setting-register-property-form">
        </ac-select>
      </ac-input-container>

      <ac-input-container label="Number/User property"
                          [customError]="registrationSettings.enabled && registrationSettings.dailablePropertyIds.length === 0 ? 'At least one property is required' : ''"
                          [required]="registrationSettings.enabled && registrationSettings.dailablePropertyIds.length === 0">
        <ac-select class="single-row"
                   [acModel]="registrationSettings.dailablePropertyIds"
                   (acModelChange)="registrationSettings.dailablePropertyIds = $event;"
                   [items]="dictionaryProperties"
                   [multiple]="true"
                   [allowClear]="true"
                   [bindValue]="'id'"
                   [bindLabel]="'name'"
                   alternativeName="registrationSettings.dailablePropertyIds">
        </ac-select>
      </ac-input-container>
    </div>
  </arm-form>
</div>
